import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import backgroundImage from '../../assets/accepted-invitation-trainer.jpg';
import API_BASE_URL from '../../config/api';

const AcceptInvite = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [athleteName, setAthleteName] = useState('');

  useEffect(() => {
    const processInvite = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/invitations/accept/${token}`);
        setMessage(res.data.message);
        setAthleteName(res.data.athleteName || '');
        setError(false);
      } catch (err) {
        setError(true);
        setMessage(err.response?.data?.message || 'Error al procesar la invitación.');
      }
    };

    processInvite();
  }, [token]);

  return (
    <div
      className="d-flex align-items-center justify-content-center text-center text-white"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        flexDirection: 'column',
        padding: '2rem'
      }}
    >
      {!error ? (
        <>
          <h2 className="text-success">
            ✅ Invitación aceptada{athleteName && `, ${athleteName}`}!
          </h2>
          <p>{message}</p>
          <div className="mt-3">
            <button className="btn btn-primary mx-2" onClick={() => navigate('/login')}>
              Iniciar Sesión
            </button>
            <button className="btn btn-success mx-2" onClick={() => navigate('/register')}>
              Registrarse
            </button>
          </div>
        </>
      ) : (
        <>
          <h2 className="text-danger">❌ Invitación no válida</h2>
          <p>{message}</p>
          <button className="btn btn-light mt-3" onClick={() => navigate('/')}>
            Volver al inicio
          </button>
        </>
      )}
    </div>
  );
};

export default AcceptInvite;
